<template>
  <div class="main-container container-xxl placeholder-glow">
    <div class="text-end sticky-top pt-4">
      <button @click="$router.go(-1)" class="btn btn-sm btn-dark">Voltar</button>
    </div>
    <div class="row mb-3">
      <titulo-grande :texto="dadosPageView.titulo_curso" :class="['col-xl-8']" posicao="left" />
      <div class="col-xl-4 text-center">
        <h6>Imagem de capa do curso</h6>
        <img :src="$api_link + 'download/img/' + dadosPageView.imagem_capa" style="max-height: 300px;"
          class="img-fluid img-thumbnail rounded" alt="">
      </div>
    </div>

    <modal :tituloModal="textoBtnCadastro" @fecha_modal="fecha_modal" @hidden="fecha_modal"
      textoBtnChamada="Inserir Aula" tamanho_modal="modal-lg" @click_bt_modal="click_bt_modal" :exibe_botao="true">

      <template #default>
        <form @submit.prevent="register" enctype="multipart/form-data" id="cad_cursos_aulas">
          <fieldset>
            <InputText placeholder="" label="Título da aula *" tamanho="sm" nome="titulo_aula" ref="titulo_aula"
              v-model="titulo_aula" />

            <InputText placeholder="" label="Link do vídeo do youtube" tamanho="sm" nome="link_video" ref="link_video"
              v-model="link_video" />

            <InputText placeholder="" :multiple="true" tipo="file" label="Arquivos para download" tamanho="sm"
              nome="arquivos" ref="arquivos" v-model="arquivos" />

            <div class="col-sm-10 offset-sm-1 my-4 placeholder-glow">
              <div class="accordion" id="accordionPanelsStayOpenExample">
                <div :class="['accordion-item', (ativa_placeholder ? 'placeholder' : '')]">
                  <h2 class="accordion-header">
                    <button class="accordion-button" type="button" data-bs-toggle="collapse"
                      data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true"
                      aria-controls="panelsStayOpen-collapseOne">
                      Arquivos da aula
                    </button>
                  </h2>
                  <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse show">
                    <div class="accordion-body">
                      <ol class="list-group list-group-numbered list-group-flush">
                        <li class="list-group-item" v-for="file in dados_arquivos_aula" :key="file.id">
                          - {{ file.nome_arquivo }}
                          <div class="float-end">
                            <a class="btn btn-sm btn-info text-light mx-1" :href="$api_link+'download/file/' + file.nome_arquivo + '/' + file.id_aula" target="_blank">
                              <i class="bi bi-cloud-arrow-down"></i>
                              Baixar
                            </a>
                            <a class="btn btn-sm btn-danger mx-1" @click="deletar_arquivo(file.id, file.id_aula)">
                              <i class="bi bi-trash3"></i>
                              Excluir
                            </a>
                          </div>
                        </li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <InputTextarea nome="descricao_aula" class="form-control" label="Descrição da aula"
              v-model="descricao_aula" />

            <input type="submit" class="d-none" value="">
          </fieldset>
        </form>
      </template>
      <template #botaoPersonalizado>
        <fieldset>
          <button type="button" @click.prevent="register" class="btn btn-primary">Salvar
            <Spinner :visivel="false" id="loading" />
          </button>
        </fieldset>
      </template>
    </modal>

    <modal tituloModal="" @fecha_modal="fecha_modal" @hidden="fecha_modal" textoBtnChamada="" tamanho_modal="modal-md"
      :exibe_botao="false" id_modal="modal_delete">
      <template #default>
        <p>
          Ao confirmar todos os arquivos associados serão deletados do sistema.
        </p>
        <p>
          Tem certeza que deseja deletar a aula <strong>"{{ titulo_delete }}"</strong>?
        </p>
      </template>
      <template #botaoPersonalizado>
        <fieldset>
          <button type="button" @click.prevent="deletar" class="btn btn-danger"><i class="bi bi-trash3-fill"></i>
            Deletar
            <Spinner :visivel="false" id="loading" />
          </button>
        </fieldset>
      </template>
    </modal>

    <TabelaDatatable :dadosData="dadosData" dadosAjax="" :showPathImage="$api_link + 'download/img/'" :btnStatus="true"
      :btnEdit="true" :btnDelete="true" :ativa_placeholder="ativa_placeholder" :columns="colunas"
      @edit_status="edit_status" @edit_row="dados_editar" @delete_row="deletar_dados"
      modal_target_delete="#modal_delete"></TabelaDatatable>
  </div>
</template>

<script>
import Modal from '@/components/Modal.vue';
import TituloGrande from '../../components/TituloGrande.vue'
import TabelaDatatable from '@/components/TabelaDatatable.vue';
import InputText from '@/components/form/InputText.vue';
import { AuthStore } from '@/stores/Auth';
import { api } from '@/services/api';
import { bloqueia_campos } from '@/assets/js/functions'
import { cadastrar, editar_status, deletar } from '@/assets/js/requests'
import { toastr } from '@/plugins/toast';
import InputTextarea from '../../components/form/InputTextarea.vue';
import InputSelect from '@/components/form/InputSelect.vue';

export default {
  components: { TituloGrande, Modal, TabelaDatatable, InputText, InputTextarea, InputSelect },
  name: 'CadCursosAulas',
  data() {
    return {
      auth: AuthStore(),
      dadosPageView: {
        titulo_aula: '',
        imagem_capa: '',
      },

      id_delete: Number,
      id_dados: null,
      titulo_delete: String,
      titulo_aula: '',
      link_video: '',
      descricao_aula: '',
      arquivos: '',
      dadosData: '',
      colunas: [
        { data: 'titulo_aula', title: 'Título da aula', width: '60%' },
        { name: 'acoes', data: 'status', title: 'Ações', width: '20%' },
      ],
      textoBtnCadastro: 'Cadastro de curso',
      ativa_placeholder: Boolean,
      dados_arquivos_aula: {},
    }
  },
  mounted() {
    this.dadosPage()
    this.listagemTabela();
  },
  methods: {
    async dadosPage() {
      this.ativa_placeholder = true
      this.dadosPageView = await api.get('courses/list/' + this.$route.params.id_curso, { Authorization: this.auth.token })
      this.ativa_placeholder = false
    },
    async listagemTabela() {
      this.ativa_placeholder = true
      this.dadosData = await api.get('courses/lesson/list/' + this.$route.params.id_curso, { Authorization: this.auth.token })

      this.ativa_placeholder = false
    },
    async register(e) {
      e.preventDefault();
      if (!this.titulo_aula) {
        toastr.alerta("Digite o nome da aula")
        return false;
      }
      const formu = document.querySelector("#cad_cursos_aulas")
      const dados = new FormData(formu)
      dados.append('descricao_aula', this.descricao_aula)
      if (this.id_dados > 0) {
        dados.append('id', this.id_dados)
      }
      const registro = await cadastrar('courses/lesson/register/' + this.$route.params.id_curso, dados);
      if (registro) {
        if (!this.id_dados) {
          this.limpa_campos()
        }
        this.listagemTabela()
      }
    },
    async edit_status(dados) {
      const edit = await editar_status('courses/lesson/change_status', dados);
      if (edit) {
        this.listagemTabela()
      } else {
        // this.$router.push('/login')
      }
    },
    async dados_editar(dados) {
      bloqueia_campos()
      var dadosEdit = await api.get('courses/lesson/list/' + this.$route.params.id_curso + '/' + dados.rowData.id, { Authorization: this.auth.token })

      this.id_dados = dados.rowData.id;
      this.titulo_aula = dadosEdit.titulo_aula;
      this.link_video = dadosEdit.link_video;
      this.descricao_aula = dadosEdit.descricao_aula;
      this.arquivos = dadosEdit.arquivos;

      await this.listar_arquivos(dados.rowData.id)

      document.querySelector("#btn_modal_cadastrar").click()
      bloqueia_campos(false)
    },
    fecha_modal() {
      this.limpa_campos()
    },
    limpa_campos() {
      this.titulo_aula = '';
      this.link_video = '';
      this.descricao_aula = '';
      this.arquivos = '';
      this.id_dados = null;
      this.dados_arquivos_aula = {};
    },
    click_bt_modal() {
      if (this.id_dados > 0) {
        this.textoBtnCadastro = 'Editando aula: ' + this.titulo_aula
      } else {
        this.textoBtnCadastro = 'Cadastrar aula'
      }
    },
    deletar_dados(dados) {
      this.id_delete = dados.rowData.id
      this.titulo_delete = dados.rowData.titulo_aula
    },
    async deletar() {
      const delet = await deletar('courses/lesson/delete', { id: this.id_delete });
      if (delet) {
        this.listagemTabela()
      }
    },
    async deletar_arquivo(id, id_aula) {
      bloqueia_campos()

      const dados = {
        id: id,
        id_aula: id_aula,
      }

      const data = await api.post('courses/lesson/files/delete', dados, { Authorization: this.auth.token });
      if (data.status == 200) {
        await this.listar_arquivos(id_aula);
      }

      bloqueia_campos(false)
    },
    async listar_arquivos(id) {
      this.ativa_placeholder = true
      this.dados_arquivos_aula = await api.get('courses/lesson/files/list/' + id, { Authorization: this.auth.token });
      this.ativa_placeholder = false
    },
    async baixar_arquivo(arquivo, diret){
      await api.get('download/file/' + arquivo + '/' + diret, { Authorization: this.auth.token })
    }
  },
}
</script>

<style></style>